import { render, staticRenderFns } from "./ServisnaFaktura.vue?vue&type=template&id=56f1de85&"
import script from "./ServisnaFaktura.vue?vue&type=script&lang=ts&"
export * from "./ServisnaFaktura.vue?vue&type=script&lang=ts&"
import style0 from "./ServisnaFaktura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports